import {
  Menu,
  X,
  Search,
  ShoppingCart,
  User,
  MapPin,
  ChevronDown,
  ChevronRight,
  Languages,
  SearchIcon,
  BadgePercent,
} from "lucide-react";
import React, { useEffect, useState, useRef } from "react";
import { categories } from "../../utils/Customer/CustomerData";
import { ImagePath } from "../../assests";
import HeaderButtons from "../../components/customer/HeaderButtons";
import ModeSwitcher from "../../components/customer/ModeSwitcher";
import { useLocation, useNavigate } from "react-router-dom";
import CheckoutStepper from "../../components/customer/CheckoutStepper";
import CartDrawer from "../../components/customer/ProductDetailComponent.tsx/CartDrawer";
import { useSelector } from "react-redux";
// Import the list endpoint hook used by your AddressManager
import { useLazyGetAddressQuery } from "../../redux/actions/Customer/profileCustomer";
import { IAddressData } from "../../types/Response/CustomerResponse";
import {
  useLazyDeleteCartQuery,
  useLazyGetUserCartQuery,
  useLazyRemoveServiceTocartQuery,
  useLazyRemoveTocartQuery,
  useUpdateCartMutation,
} from "../../redux/actions/Customer/cartCustomer";
import HeaderDrawer from "../../components/customer/HeaderDrawer";
import { useMenu } from "../../components/customer/MenuContext";
import ProfileHoverMenu from "../../components/customer/ProfileHoverMenu";
import { useLazyGetSearchSuggestionsQuery } from "../../redux/actions/Customer/serviceCustomer";
import { RootState } from "../../redux/rootReducer";
import { useAnalytics } from "../../utils/Customer/useAnalytics";
interface CustomerHeaderProps {
  currentMode: string;
  setCurrentMode: (mode: "Products" | "Pets" | "Services") => void;
  handleCheckoutClick: () => void;
  onLoginRequired: () => void;
  isMobile?: boolean;
}

const CustomerWithServiceHeader: React.FC<CustomerHeaderProps> = ({
  currentMode,
  setCurrentMode,
  handleCheckoutClick,
  onLoginRequired,
  isMobile,
}) => {
  const [searchFocused, setSearchFocused] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState<string | null>(null);
  const [openGroup, setOpenGroup] = useState<string | null>(null);
  const location = useLocation();
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [profileMenuTimeout, setProfileMenuTimeout] =
    useState<NodeJS.Timeout | null>(null);
  const [cart, setCart] = useState<any[]>([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const isLoggedIn = useSelector(
    (state: RootState) => state.auth.customer.isLoggedIn,
  );
  const UserName = localStorage.getItem("userName");

  const navigate = useNavigate();
  const { menu } = useMenu();
  const [triggerGetCart, { data: cartData }] = useLazyGetUserCartQuery();
  const [updateCart] = useUpdateCartMutation();

  // Ref for handling clicks outside search box container
  const searchContainerRef = useRef<HTMLDivElement>(null);

  // Calculate total item count in cart
  const totalCartCount =
    cartData?.productCart?.items?.reduce(
      (total: number, item: any) => total + (item.quantity || 1),
      0,
    ) || 0;

  const totalItmes = cartData?.totalItems || 0;

  const [triggerDeleteCart] = useLazyDeleteCartQuery();

  const [triggerRefreshCart] = useLazyGetUserCartQuery();

  const [
    triggerSearchSuggestions,
    { data: suggestions, isFetching: isSuggestionsLoading },
  ] = useLazyGetSearchSuggestionsQuery();

  const products = suggestions?.products ?? [];
  const brands = suggestions?.brands ?? [];
  const categories = suggestions?.categories ?? [];
  const pets = suggestions?.pets ?? [];
  // State to hold the delivery string display value
  const [deliveryLocationText, setDeliveryLocationText] = useState<string>(
    "Delivering to Dubai",
  );
  const [searchText, setSearchText] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  // RTK Query Hook hook engine instantiation
  const [triggerFetchAddress] = useLazyGetAddressQuery();
  const [triggerRemoveFromCart] = useLazyRemoveTocartQuery();
  const [triggerServiceFromCart] = useLazyRemoveServiceTocartQuery();
  const checkoutRoutes = [
    "/cartpage/customercartpage",
    "/cartpage/customeraddresspage",
  ];
  const { trackSearch } = useAnalytics();
  const fetchLatestHeaderCart = async () => {
    try {
      await triggerRefreshCart().unwrap();
    } catch (error) {
      console.error(error);
    }
  };

  const handleHeaderCartIncrement = async (cartItemId: number) => {
    const currentItem = cartData?.productCart?.items?.find(
      (item) => item.cartItemId === cartItemId,
    );

    if (!currentItem) return;

    try {
      await updateCart({
        cartItemId,
        quantity: currentItem.quantity + 1,
      }).unwrap();

      await fetchLatestHeaderCart();
    } catch (error) {
      console.error(error);
    }
  };

  const handleHeaderCartDecrement = async (cartItemId: number) => {
    const currentItem = cartData?.productCart?.items?.find(
      (item) => item.cartItemId === cartItemId,
    );

    if (!currentItem) return;

    try {
      if (currentItem.quantity <= 1) {
        await triggerDeleteCart(cartItemId).unwrap();
      } else {
        await updateCart({
          cartItemId,
          quantity: currentItem.quantity - 1,
        }).unwrap();
      }

      await fetchLatestHeaderCart();
    } catch (error) {
      console.error(error);
    }
  };

  const handleHeaderCartRemove = async (cartItemId: number) => {
    try {
      await triggerDeleteCart(cartItemId).unwrap();

      await fetchLatestHeaderCart();
    } catch (error) {
      console.error(error);
    }
  };

  const handleRemovePetCartItem = async (cartItemId: Number) => {
    try {
      await triggerRemoveFromCart(Number(cartItemId)).unwrap();
      await fetchLatestHeaderCart();
    } catch (err) {
      console.error("Error running deletion transaction cycle:", err);
    }
  };
  const handleRemoveServiceCartItem = async (cartItemId: Number) => {
    try {
      await triggerServiceFromCart(Number(cartItemId)).unwrap();
      await fetchLatestHeaderCart();
    } catch (err) {
      console.error("Error running deletion transaction cycle:", err);
    }
  };

  const handleCartClick = async () => {
    if (isLoggedIn) {
      try {
        await triggerGetCart().unwrap();
        setIsCartOpen(true);
      } catch (error) {
        console.log(error);
      }
    } else {
      onLoginRequired();
    }
  };

  const handleProfileClick = () => {
    if (isLoggedIn) {
      setMenuOpen(false);

      navigate("customerprofilescreen");
    } else {
      onLoginRequired();
    }
  };

  // Handler when user triggers a click on address title block locations
  const handleLocationClick = () => {
    if (isLoggedIn) {
      // Pass the tab's id inside your state packet
      setMenuOpen(false);
      navigate("customerprofilescreen", { state: { activeTab: "addresses" } });
    } else {
      onLoginRequired();
    }
  };
  const isCheckoutFlow = checkoutRoutes.includes(location.pathname);

  const handleProfileMouseEnter = () => {
    if (profileMenuTimeout) {
      clearTimeout(profileMenuTimeout);
    }

    setShowProfileMenu(true);
  };

  const handleProfileMouseLeave = () => {
    const timeout = setTimeout(() => {
      setShowProfileMenu(false);
    }, 180);

    setProfileMenuTimeout(timeout);
  };

  const handleSaleClick = () => {
    navigate("/productpage/productListingScreen", {
      state: {
        source: "SpecialOffer",
        data: {
          onlyOnSale: true,
          title: "Special Offers",
        },
      },
    });
  };

  const handleSearch = () => {
    const text = searchText.trim();

    if (!text) return;

    // --------------------------------------------
    // Analytics: Search
    // --------------------------------------------
    trackSearch(text);

    setShowSuggestions(false);
    setIsSearchOpen(false);

    navigate("/productpage/productListingScreen", {
      state: {
        source: "Search",
        data: {
          query: text,
        },
      },
    });
  };

  // Close search suggestions when user clicks anywhere outside the search container
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target as Node)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      triggerGetCart();
    }
  }, [isLoggedIn, triggerGetCart]);

  useEffect(() => {
    const text = searchText.trim();

    if (text.length < 2) {
      setShowSuggestions(false);
      return;
    }

    const timer = setTimeout(async () => {
      try {
        const result = await triggerSearchSuggestions({
          query: text,
          productTake: 5,
          brandTake: 3,
          categoryTake: 3,
          petTake: 5
        }).unwrap();

        setShowSuggestions(true);
      } catch (err) {
        console.log(err);
        setShowSuggestions(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText]);

  // Fetch live default delivery string data dynamically if logged in
  useEffect(() => {
    const fetchDeliveryAddress = async () => {
      const shortenText = (text: string | null) => {
        if (!text) return "Delivering to Dubai";
        return text.length > 15 ? text.substring(0, 15) + "..." : text;
      };

      if (!isLoggedIn) {
        const savedLocation = localStorage.getItem("location");
        setDeliveryLocationText(
          savedLocation ? shortenText(savedLocation) : "Delivering to Dubai",
        );
        return;
      }

      try {
        const response = await triggerFetchAddress().unwrap();
        const addressList: IAddressData[] = response?.data || response || [];

        if (Array.isArray(addressList) && addressList.length > 0) {
          const defaultAddress =
            addressList.find((addr) => addr.isDefault) || addressList[0];

          const formatted =
            defaultAddress.city || defaultAddress.addressLine1 || "Dubai";

          setDeliveryLocationText(`Deliver to ${shortenText(formatted)}`);
        } else {
          setDeliveryLocationText("Delivering to Dubai");
        }
      } catch (error) {
        console.error(
          "Failed header address evaluation calculation metrics:",
          error,
        );
        setDeliveryLocationText("Delivering to Dubai");
      }
    };

    fetchDeliveryAddress();
  }, [isLoggedIn, location.pathname, triggerFetchAddress]);

  // If user has set an address, hide "Update location"; show it only if default/fallback is showing
  const locationSubtitle =
    deliveryLocationText === "Delivering to Dubai"
      ? "Update location"
      : undefined;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isSearchOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSearchOpen]);

  const currentStep = location.pathname.includes("address")
    ? 1
    : location.pathname.includes("payment")
      ? 2
      : 0;

  return (
    <>
      {/* Dynamic Keyframes for Blinking Animation */}
      <style>{`
  @keyframes saleZoom {
    0%, 100% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.2);
    }
  }

  .animate-sale-zoom {
    animation: saleZoom 1s ease-in-out infinite;
  }
`}</style>

      {/* ================= HEADER ================= */}
      <div className="w-full h-[60px] flex items-center justify-between bg-logoHeading px-3 md:px-4 lg:px-4 relative z-40">
        {/* LEFT */}
        <div className="flex items-center gap-3">
          <button className="lg:hidden" onClick={() => setMenuOpen(true)}>
            <Menu className="w-5 h-5 text-white" />
          </button>

          <div className="block">
            <img
              src={ImagePath.Logo}
              className="h-5 lg:h-6 object-contain cursor-pointer"
              alt="logo"
              onClick={() => {
                setMenuOpen(false);
                navigate("/");
              }}
            />
          </div>
        </div>

        {isCheckoutFlow ? (
          <CheckoutStepper currentStep={currentStep} />
        ) : (
          <>
            <div className="hidden lg:block">
              <ModeSwitcher
                activeMode={currentMode}
                onModeChange={setCurrentMode}
              />
            </div>

            {/* DESKTOP SEARCH */}
            <div
              ref={searchContainerRef}
              className="hidden lg:flex flex-1 lg:max-w-[350px] relative"
            >
              {showSuggestions && (
                <div
                  className="
      absolute
      top-full
      left-0
      right-0
      mt-2
      bg-white
      rounded-xl
      shadow-xl
      border
      border-gray-100
      z-50
      overflow-hidden
      max-h-[70vh]
      overflow-y-auto
      overscroll-contain
      scrollbar-thin
    "
                >
                  {isSuggestionsLoading && (
                    <div className="p-4 text-center text-sm text-gray-500">
                      Searching...
                    </div>
                  )}

                  {!isSuggestionsLoading && (
                    <>
                      {/* If everything is empty, display a clean "No results found" message */}
                      {(!products || products.length === 0) &&
                        (!brands || brands.length === 0) &&
                        (!categories || categories.length === 0) &&
                        (!pets || pets.length === 0) ? (
                        <div className="p-6 text-center flex flex-col items-center justify-center gap-2">
                          <Search className="w-8 h-8 text-gray-300" />
                          <p className="text-sm font-medium text-gray-600">
                            No results found
                          </p>
                          <p className="text-xs text-gray-400 px-4">
                            We couldn't find anything matching "{searchText}".
                            Try checking your spelling.
                          </p>
                        </div>
                      ) : (
                        <>
                          {/* Products */}
                          {products?.length > 0 && (
                            <>
                              <div className="px-4 py-2 text-xs font-semibold uppercase text-gray-400">
                                Products
                              </div>
                              {products.map((item: any) => (
                                <button
                                  key={item.productId}
                                  className="w-full px-4 py-3 hover:bg-gray-50 flex items-center gap-3 text-left"
                                  onClick={() => {
                                    setShowSuggestions(false);
                                    navigate(
                                      `/productpage/customerneproductpage/${item.productId}`,
                                    );
                                  }}
                                >
                                  <img
                                    src={item.imageUrl}
                                    alt={item.name}
                                    className="w-14 h-14 rounded-lg border object-cover"
                                  />
                                  <div className="flex-1 text-left">
                                    <div className="font-medium text-sm text-gray-800 line-clamp-2">
                                      {item.name}
                                    </div>
                                    <div className="mt-1 flex items-center gap-2">
                                      {item.salePrice > 0 ? (
                                        <>
                                          <span className="font-semibold text-mediumGreen">
                                            AED {item.salePrice.toFixed(2)}
                                          </span>
                                          <span className="text-xs text-gray-400 line-through">
                                            AED {item.price.toFixed(2)}
                                          </span>
                                        </>
                                      ) : (
                                        <span className="font-semibold text-mediumGreen">
                                          AED {item.price.toFixed(2)}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </button>
                              ))}
                            </>
                          )}
                          {/* Pets */}
                          {pets?.length > 0 && (
                            <>
                              <div className="px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-t">
                                Pets
                              </div>

                              {pets.map((item: any) => (
                                <button
                                  key={item.petId}
                                  className="w-full px-4 py-3 hover:bg-gray-50 flex items-center gap-3 text-left"
                                  onClick={() => {
                                    setShowSuggestions(false);

                                    navigate(`/productpage/PetDetailScreen/${item.petId}`);
                                  }}
                                >
                                  <img
                                    src={item.productImage}
                                    alt={item.petName}
                                    className="w-14 h-14 rounded-lg border object-cover"
                                  />

                                  <div className="flex-1 min-w-0">
                                    <div className="font-medium text-sm text-gray-800 line-clamp-2">
                                      {item.petName}
                                    </div>

                                    <div className="text-xs text-gray-500 mt-1">
                                      {item.breed}
                                    </div>

                                    <div className="mt-1 flex items-center gap-2">
                                      {item.salePrice > 0 && item.salePrice < item.price ? (
                                        <>
                                          <span className="font-semibold text-mediumGreen">
                                            AED {item.salePrice.toFixed(2)}
                                          </span>

                                          <span className="text-xs text-gray-400 line-through">
                                            AED {item.price.toFixed(2)}
                                          </span>
                                        </>
                                      ) : (
                                        <span className="font-semibold text-mediumGreen">
                                          AED {item.price?.toFixed(2)}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </button>
                              ))}
                            </>
                          )}

                          {/* Brands */}
                          {brands?.length > 0 && (
                            <>
                              <div className="px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-t">
                                Brands
                              </div>
                              {brands.map((item: any) => (
                                <button
                                  key={item.brandId}
                                  className="w-full px-4 py-2 text-left hover:bg-gray-50 text-sm"
                                  onClick={() => {
                                    setShowSuggestions(false);
                                    navigate(
                                      "/productpage/productListingScreen",
                                      {
                                        state: {
                                          source: "Brand",
                                          data: {
                                            brandId: item.brandId,
                                            title: item.name,
                                          },
                                        },
                                      },
                                    );
                                  }}
                                >
                                  {item.name}
                                </button>
                              ))}
                            </>
                          )}

                          {/* Categories */}
                          {categories?.length > 0 && (
                            <>
                              <div className="px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-t">
                                Categories
                              </div>
                              {categories.map((item: any) => (
                                <button
                                  key={item.categoryId}
                                  className="w-full px-4 py-2 text-left hover:bg-gray-50 text-sm"
                                  onClick={() => {
                                    setShowSuggestions(false);
                                    navigate(
                                      "/productpage/productListingScreen",
                                      {
                                        state: {
                                          source: "Category",
                                          data: {
                                            categoryId: item.categoryId,
                                            title: item.name,
                                          },
                                        },
                                      },
                                    );
                                  }}
                                >
                                  {item.name}
                                </button>
                              ))}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Search Bar Input */}
              <div
                className={`flex w-full bg-lightgray rounded-full overflow-hidden transition-all duration-200 relative ${searchFocused
                    ? "shadow-[0_0_0_2px_rgba(47,94,46,0.15),0_4px_12px_rgba(0,0,0,0.08)]"
                    : "shadow-sm"
                  }`}
              >
                <div className="relative flex-1 flex items-center">
                  <input
                    type="text"
                    value={searchText}
                    placeholder="Search..."
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    className="w-full bg-transparent pl-3 pr-8 py-2 text-sm outline-none"
                    onFocus={() => {
                      setSearchFocused(true);
                      if (searchText.length >= 2) setShowSuggestions(true);
                    }}
                  />

                  {/* Clear (X) Button - Shows only when searchText is not empty */}
                  {searchText && (
                    <button
                      type="button"
                      onClick={() => {
                        setSearchText("");
                        setShowSuggestions(false);
                      }}
                      className="absolute right-2 p-1 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-200/50 transition-colors"
                      aria-label="Clear search text"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                </div>

                <button
                  className="bg-mediumGreen text-white px-3 py-2 text-sm flex items-center gap-2 rounded-r-full shrink-0"
                  onClick={handleSearch}
                >
                  <Search className="w-4 h-4" />
                  <span className="hidden lg:block">Search</span>
                </button>
              </div>
            </div>

            {/* LOCATION (Desktop only) */}
            <div className="hidden lg:flex items-center gap-2">
              {/* Delivery Location Button */}
              <HeaderButtons
                icon={<MapPin size={18} />}
                title={deliveryLocationText}
                subtitle={locationSubtitle}
                className="text-white cursor-pointer"
                handleButtonClick={handleLocationClick}
              />

              {/* Profile / Sign In Section */}
              {!isLoggedIn ? (
                <HeaderButtons
                  icon={<User size={20} />}
                  subtitle="Sign in"
                  className="text-white"
                  handleButtonClick={handleProfileClick}
                />
              ) : (
                <div
                  className="relative flex items-center"
                  onMouseEnter={handleProfileMouseEnter}
                  onMouseLeave={handleProfileMouseLeave}
                >
                  <HeaderButtons
                    icon={<User size={20} />}
                    subtitle={UserName || "Guest"}
                    className="text-white"
                    handleButtonClick={() => navigate("customerprofilescreen")}
                  />

                  {showProfileMenu && (
                    <ProfileHoverMenu
                      onProfile={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "profile" },
                        })
                      }
                      onOrders={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "orders" },
                        })
                      }
                      onAddresses={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "addresses" },
                        })
                      }
                      onOrderSubscription={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "Subscription" },
                        })
                      }
                      onWallet={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "wallet" },
                        })
                      }
                      onApplications={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "myApplications" },
                        })
                      }
                      onBookings={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "myBookings" },
                        })
                      }
                      onReferral={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "referral" },
                        })
                      }
                      onRewards={() => {
                        console.log("Rewards Clicked");
                      }}
                      onNotifications={() => {
                        console.log("Notifications Clicked");
                      }}
                      onLogout={() =>
                        navigate("customerprofilescreen", {
                          state: { activeTab: "signout" },
                        })
                      }
                    />
                  )}
                </div>
              )}

              {/* Cart Button */}
              <HeaderButtons
                icon={
                  <div className="relative inline-flex items-center">
                    <ShoppingCart size={20} />
                    {totalItmes > 0 && (
                      <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] px-1 flex items-center justify-center">
                        {totalItmes > 99 ? "99+" : totalItmes}
                      </span>
                    )}
                  </div>
                }
                title="Cart"
                layout="horizontal"
                className="text-white"
                handleButtonClick={handleCartClick}
              />
            </div>

            <div className="hidden md:flex lg:hidden items-center gap-3">
              <HeaderButtons
                icon={<SearchIcon size={20} />}
                title="Search"
                layout="horizontal"
                className="text-white"
                handleButtonClick={() => setIsSearchOpen(!isSearchOpen)}
              />

              <HeaderButtons
                icon={
                  <div className="relative inline-flex items-center">
                    <ShoppingCart size={20} />
                    {totalCartCount > 0 && (
                      <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] px-1 flex items-center justify-center">
                        {totalCartCount > 99 ? "99+" : totalCartCount}
                      </span>
                    )}
                  </div>
                }
                title="Cart"
                layout="horizontal"
                className="text-white"
                handleButtonClick={handleCartClick}
              />
            </div>

            {/* MOBILE ACTION BAR */}
            <div className="flex items-center md:hidden">
              <HeaderButtons
                icon={<SearchIcon size={20} />}
                layout="horizontal"
                className="text-white"
                handleButtonClick={() => setIsSearchOpen(!isSearchOpen)}
              />

              {/* RED & BLINKING OFFER ICON BUTTON */}
              {/* OFFER GIF BUTTON */}
              <button
                type="button"
                onClick={handleSaleClick}
                className="flex items-center justify-center cursor-pointer"
                aria-label="Special Offers"
              >
                <img
                  src={ImagePath.Saleicon}
                  alt="Special Offers"
                  className="w-7 h-7 object-contain animate-sale-zoom"
                />
              </button>

              <HeaderButtons
                icon={
                  <div className="relative inline-flex items-center">
                    <ShoppingCart size={20} />
                    {totalCartCount > 0 && (
                      <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] px-1 flex items-center justify-center">
                        {totalCartCount > 99 ? "99+" : totalCartCount}
                      </span>
                    )}
                  </div>
                }
                layout="horizontal"
                className="text-white"
                handleButtonClick={handleCartClick}
              />
            </div>
          </>
        )}
      </div>

      {/* ================= MOBILE DRAWER ================= */}
      <div
        className={`lg:hidden fixed inset-0 z-50 transition-opacity duration-300 ${menuOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
          }`}
      >
        {/* Backdrop overlay with fade */}
        <div
          className="absolute inset-0 bg-black/50 backdrop-blur-xs transition-opacity"
          onClick={() => setMenuOpen(false)}
          aria-hidden="true"
        />

        {/* Sliding Drawer Container */}
        <aside
          className={`absolute top-0 left-0 h-full w-[300px] sm:w-[320px] bg-white flex flex-col shadow-2xl transform transition-transform duration-300 ease-out ${menuOpen ? "translate-x-0" : "-translate-x-full"
            }`}
        >
          {/* Drawer Header */}
          <div className="p-4 flex items-center justify-between border-b border-gray-100 bg-white sticky top-0 z-10">
            <img
              src={ImagePath.Logo}
              className="h-7 object-contain cursor-pointer"
              alt="Brand Logo"
              onClick={() => {
                setMenuOpen(false);
                navigate("/");
              }}
            />
            <button
              type="button"
              onClick={() => setMenuOpen(false)}
              className="p-1.5 rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
              aria-label="Close menu"
            >
              <X size={20} />
            </button>
          </div>

          {/* Header Action Badges */}
          <div className="p-4 bg-gray-50/80 border-b border-gray-100 flex flex-col gap-2.5">
            <HeaderButtons
              icon={<MapPin size={15} />}
              title={deliveryLocationText}
              layout="horizontal"
              className="text-white bg-iconColor rounded-lg px-3 h-[38px] w-full font-medium shadow-xs hover:opacity-95 transition-opacity"
              textclass="text-xs sm:text-sm font-medium"
              handleButtonClick={() => {
                setMenuOpen(false);
                handleLocationClick();
              }}
            />

            <HeaderButtons
              icon={<User size={16} />}
              title={isLoggedIn ? UserName || "My Account" : "Hello, Sign in"}
              layout="horizontal"
              className="text-white bg-iconColor rounded-lg px-3 h-[38px] w-full font-medium shadow-xs hover:opacity-95 transition-opacity"
              textclass="text-xs sm:text-sm font-medium"
              handleButtonClick={() => {
                setMenuOpen(false);
                handleProfileClick();
              }}
            />
          </div>

          {/* Scrollable Navigation Body */}
          <div className="flex-1 overflow-y-auto divide-y divide-gray-100">
            {/* Category Section - Displays ONLY current active mode categories */}
            <nav className="py-2">
              <div className="px-4 py-2">
                <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400">
                  Browse Categories
                </p>
              </div>

              {(() => {
                // Find the active section matching ONLY the current selected mode
                const activeModeMenu = (menu || []).find(
                  (cat: any) =>
                    cat.name.toLowerCase() === currentMode.toLowerCase(),
                );

                const categoriesToDisplay = activeModeMenu?.children || [];

                if (categoriesToDisplay.length === 0) {
                  return (
                    <div className="px-4 py-3 text-xs text-gray-400 font-medium">
                      No categories found.
                    </div>
                  );
                }

                return categoriesToDisplay.map((group: any, index: number) => {
                  const groupKey = `${currentMode}-${group.name}`;
                  const isGroupOpen = openCategory === groupKey;

                  return (
                    <div
                      key={group.id || index}
                      className="select-none border-b last:border-b-0 border-gray-100"
                    >
                      <button
                        type="button"
                        className={`w-full flex items-center justify-between px-4 py-3 text-left transition-colors ${isGroupOpen
                            ? "bg-headerGreen-light/10 text-mainBrandColor font-semibold border-l-4 border-mainBrandColor"
                            : "text-gray-800 hover:bg-gray-50 font-medium"
                          }`}
                        onClick={() => {
                          if (isGroupOpen) {
                            setOpenCategory(null);
                            setOpenGroup(null);
                          } else {
                            setOpenCategory(groupKey);
                            setOpenGroup(null);
                          }

                          if (!group.children?.length) {
                            setMenuOpen(false);
                            const targetPath =
                              currentMode === "Pets"
                                ? "/productpage/customerpetlistingscreen"
                                : "/productpage/productListingScreen";

                            navigate(targetPath, {
                              state: {
                                source:
                                  currentMode === "Pets"
                                    ? "PetCategory"
                                    : "Category",
                                data: {
                                  categoryId: group.id,
                                  title: group.name,
                                },
                              },
                            });
                          }
                        }}
                      >
                        <span className="text-xs sm:text-sm">{group.name}</span>

                        {group.children?.length > 0 && (
                          <ChevronDown
                            className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${isGroupOpen
                                ? "rotate-180 text-mainBrandColor"
                                : ""
                              }`}
                          />
                        )}
                      </button>

                      {/* Subcategories Level 1 */}
                      {isGroupOpen && group.children?.length > 0 && (
                        <div className="bg-gray-50/50 border-t border-gray-100 py-1">
                          {group.children.map((subChild: any) => (
                            <button
                              key={subChild.id}
                              type="button"
                              className="w-full flex items-center justify-between pl-8 pr-4 py-2 text-xs text-gray-600 hover:text-mainBrandColor hover:bg-gray-100/60 transition-colors"
                              onClick={() => {
                                setOpenCategory(null);
                                setOpenGroup(null);
                                setMenuOpen(false);

                                const targetPath =
                                  currentMode === "Pets"
                                    ? "/productpage/customerpetlistingscreen"
                                    : "/productpage/productListingScreen";

                                navigate(targetPath, {
                                  state: {
                                    source:
                                      currentMode === "Pets"
                                        ? "PetCategory"
                                        : "Category",
                                    data: {
                                      categoryId: subChild.id,
                                      title: subChild.name,
                                    },
                                  },
                                });
                              }}
                            >
                              <span>{subChild.name}</span>
                              <ChevronRight className="w-3.5 h-3.5 opacity-60" />
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                });
              })()}
            </nav>

            {/* Shop Navigation Links */}
            <div className="py-2">
              <div className="px-4 py-2">
                <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400">
                  Shop
                </p>
              </div>

              {[
                {
                  label: "Brands",
                  path: "/productpage/customerbrandpage",
                  state: {
                    source: "Brands",
                    data: {
                      title: "Brands",
                    },
                  },
                },
                {
                  label: "Special Offers",
                  path: "/productpage/productListingScreen",
                  state: {
                    source: "SpecialOffer",
                    data: {
                      onlyOnSale: true,
                      title: "Special Offers",
                    },
                  },
                },
                {
                  label: "New Arrivals",
                  path: "/productpage/productListingScreen",
                  state: {
                    source: "New Arrivals",
                    data: {
                      onlyNewArrivals: true,
                      title: "New Arrivals",
                    },
                  },
                },
                {
                  label: "Best Seller",
                  path: "/productpage/productListingScreen",
                  state: {
                    source: "BestSeller",
                    data: {
                      onlyBestSeller: true,
                      title: "Best Seller",
                    },
                  },
                },
              ].map((item) => (
                <button
                  key={item.label}
                  type="button"
                  className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-mainBrandColor font-medium transition-colors"
                  onClick={() => {
                    setMenuOpen(false);

                    navigate(item.path, {
                      state: item.state,
                    });
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Drawer Footer Actions (Sticky Bottom) */}
          <div className="p-4 border-t border-gray-100 bg-white flex flex-col gap-3">
            {/* Language Selection */}


            {/* Dynamic Sign In / Sign Out Button */}
            {isLoggedIn ? (
              <button
                type="button"
                className="w-full flex items-center justify-center py-2.5 text-xs sm:text-sm font-semibold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                onClick={() => {
                  setMenuOpen(false);
                  navigate("customerprofilescreen", {
                    state: { activeTab: "signout" },
                  });
                }}
              >
                Sign Out
              </button>
            ) : (
              <button
                type="button"
                className="w-full flex items-center justify-center py-2.5 text-xs sm:text-sm font-semibold text-mainBrandColor bg-headerGreen-light/10 hover:bg-headerGreen-light/20 rounded-lg transition-colors"
                onClick={() => {
                  setMenuOpen(false);
                  onLoginRequired();
                }}
              >
                Sign In
              </button>
            )}
          </div>
        </aside>
      </div>

      {/* ================= REDESIGNED MOBILE SEARCH DROPDOWN BAR ================= */}
      <div
        className={`lg:hidden fixed left-0 right-0 top-[60px] z-40 bg-white border-b shadow-lg transition-all duration-300 transform origin-top ${isSearchOpen
            ? "translate-y-0 opacity-100 pointer-events-auto"
            : "-translate-y-2 opacity-0 pointer-events-none"
          }`}
      >
        <div className="p-3 flex items-center gap-2 max-w-2xl mx-auto">
          <div className="flex-1 flex items-center bg-gray-100 rounded-full px-3 py-1.5 border border-gray-200 focus-within:border-mediumGreen">
            <Search className="w-4 h-4 text-gray-500 mr-2 shrink-0" />
            <input
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              placeholder="Search products..."
              autoFocus={isSearchOpen}
              className="w-full bg-transparent text-sm outline-none text-gray-800 placeholder-gray-400"
            />
          </div>
          <button
            onClick={() => {
              setSearchText("");
              setShowSuggestions(false);
              setIsSearchOpen(false);
            }}
            className="p-1.5 text-gray-500 hover:text-gray-800 transition-colors rounded-full hover:bg-gray-100"
            aria-label="Close search"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        {showSuggestions && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-xl border border-gray-100 z-50 overflow-hidden max-h-[70vh] overflow-y-auto">
            {isSuggestionsLoading && (
              <div className="p-4 text-center text-sm text-gray-500">
                Searching...
              </div>
            )}

            {!isSuggestionsLoading && (
              <>
                {/* Mobile No Results State */}
                {(!products || products.length === 0) &&
                  (!brands || brands.length === 0) &&
                  (!categories || categories.length === 0) ? (
                  <div className="p-6 text-center flex flex-col items-center justify-center gap-2">
                    <Search className="w-7 h-7 text-gray-300" />
                    <p className="text-sm font-medium text-gray-600">
                      No results found
                    </p>
                    <p className="text-xs text-gray-400 px-4">
                      We couldn't find matching items for "{searchText}".
                    </p>
                  </div>
                ) : (
                  <>
                    {/* Products */}
                    {products?.length > 0 && (
                      <div className="py-2">
                        <div className="px-4 py-1 text-[11px] font-bold uppercase tracking-wider text-gray-400">
                          Products
                        </div>
                        {products.map((item: any) => (
                          <button
                            key={item.productId}
                            className="w-full px-4 py-2.5 hover:bg-gray-50 flex items-center gap-3 text-left transition-colors"
                            onClick={() => {
                              setShowSuggestions(false);
                              setIsSearchOpen(false);
                              navigate(
                                `/productpage/customerneproductpage/${item.productId}`,
                              );
                            }}
                          >
                            <div className="w-12 h-12 rounded-md border border-gray-100 bg-gray-50 overflow-hidden shrink-0 flex items-center justify-center">
                              <img
                                src={item.imageUrl}
                                alt={item.name}
                                className="w-full h-full object-contain p-0.5"
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="font-medium text-xs sm:text-sm text-gray-800 line-clamp-2 leading-snug">
                                {item.name}
                              </div>
                              <div className="mt-0.5 flex items-center gap-1.5">
                                {item.salePrice > 0 ? (
                                  <>
                                    <span className="font-semibold text-xs text-mediumGreen">
                                      AED {item.salePrice.toFixed(2)}
                                    </span>
                                    <span className="text-[10px] text-gray-400 line-through">
                                      AED {item.price.toFixed(2)}
                                    </span>
                                  </>
                                ) : (
                                  <span className="font-semibold text-xs text-mediumGreen">
                                    AED {item.price?.toFixed(2)}
                                  </span>
                                )}
                              </div>
                            </div>
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Brands */}
                    {brands?.length > 0 && (
                      <>
                        <div className="px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-t">
                          Brands
                        </div>

                        {brands.map((item: any) => (
                          <button
                            key={item.brandId}
                            className="w-full px-4 py-2 text-left hover:bg-gray-50 text-sm"
                            onClick={() => {
                              setShowSuggestions(false);

                              navigate("/productpage/productListingScreen", {
                                state: {
                                  source: "Brand",
                                  data: {
                                    brandId: item.brandId,
                                    title: item.name,
                                  },
                                },
                              });
                            }}
                          >
                            {item.name}
                          </button>
                        ))}
                      </>
                    )}
                  </>
                )}
                {/* Categories */}

                {categories?.length > 0 && (
                  <>
                    <div className="px-4 py-2 text-xs font-semibold uppercase text-gray-400 border-t">
                      Categories
                    </div>

                    {categories.map((item: any) => (
                      <button
                        key={item.categoryId}
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 text-sm"
                        onClick={() => {
                          setShowSuggestions(false);

                          navigate("/productpage/productListingScreen", {
                            state: {
                              source: "Category",
                              data: {
                                categoryId: item.categoryId,
                                title: item.name,
                              },
                            },
                          });
                        }}
                      >
                        {item.name}
                      </button>
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        )}
      </div>

      {/* Backdrop overlay for mobile search dropdown */}
      {isSearchOpen && (
        <div
          className="lg:hidden fixed inset-0 top-[60px] bg-black/30 backdrop-blur-[1px] z-30"
          onClick={() => setIsSearchOpen(false)}
          aria-hidden="true"
        />
      )}

      <HeaderDrawer
        cartData={cartData}
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        onIncrement={handleHeaderCartIncrement}
        onDecrement={handleHeaderCartDecrement}
        onRemove={handleHeaderCartRemove}
        onRemovePet={handleRemovePetCartItem}
        onRemoveService={handleRemoveServiceCartItem}
        handleCheckoutClick={handleCheckoutClick}
        onAddToCart={function (product: any): void {
          throw new Error("Function not implemented.");
        }}
      />
    </>
  );
};

export default CustomerWithServiceHeader;
